//离线下载用js
import commonUtils from "@/js/workspace/common_util.js";
import requestUtils from "../request_util";
import taskOfflineUtils from '@/js/workspace/task_offline_util.js';
export default {
    direction: null,
    init(direction) {
        this.direction = direction;
    },
    //web离线上传前置校验
    submitOffLine(cloudSite,callBack) {
        // 权限检查
        if(cloudSite.driveType == 'google_drive_sharedWithMe' || cloudSite.driveType == 'gSuiteSharedDrive'){
            let uploadData = {
                dd:cloudSite.driveId,
                tid:cloudSite.fileId,
                ud: commonUtils.getUser().id
            };
            requestUtils.doFilesRequest("upload.createSession", uploadData ,{timeout:1800000}).then(result => {
                requestUtils.doFilesRequest(result.upload_id + "/upload_check", uploadData ,{timeout:1800000}).then(res => {
                    if(res.status == 401){
                        this.direction.$toast({
                            text: this.direction.$t('language.exception.' + res.reason),
                            type: 'fail',
                            idValue: "rightContBan"
                        });
                        callBack();
                    }else{
                        callBack(200);
                    }
                });
            });
        }else{
            callBack(200);
        }
    },
    //web离线上传
    doRequestIfWeb(taskName,textLink,cloudSite,sendEmail,callBack) {
        if (!this.vertifiWeb(textLink)) {
            this.showBannel(this.direction.$t('language.popup.remoteTaskPopup.downloadLink'), "rightContBan");
            callBack();
            return;
        }
        
        let that = this;
        var options = {};
        //任务设置信息，包括任务名和是否发送邮件
        options.name = taskName;
        if(sendEmail){
            options.email = sendEmail;
        }
        var addOffData = new taskOfflineUtils.addOffLineTask(commonUtils.getUser().id, 3, taskName, textLink, cloudSite, options);
        requestUtils.doTasksRequest("add", addOffData).then(res => {
            console.log(res)
            if (res.status == 200) {
                callBack(res);
            } else {
                let text = null;
                if (res.reason == 'trafficNotEnough') {
                    text = that.$t('language.popup.upgradeAccountPopup.insufficientTrafficDes');
                }
                if (res.reason == 'saltInvalid') {
                    text = that.$t('language.exception.saltInvalid');
                }
                if (res.reason == 'taskMaximumNumberLimited') {
                    text = that.$t('language.exception.remoteTask.maxLimit');
                }
                that.showBannel(text == null ? that.direction.$t('language.exception.' + res.reason) : text, "allBox");
                callBack();
            }
        }, err => {
            that.showBannel(err, "allBox");
            callBack();
        });
    },
    vertifiWeb(textLink) {
        if (textLink) {
            const browsingItemLinkHttp = textLink.substr(0, 7).toLowerCase();
            const browsingItemLinkHttps = textLink.substr(0, 8).toLowerCase();
            // https、https
            if (browsingItemLinkHttp == "http://" || browsingItemLinkHttps == "https://") {
                return true;
            }
        }
        return false;
    },
    //种子上传文件（任务名，文件下载id，文件下载类型，选中传输集合，目标云盘，提醒邮件地址：可为空）
    torrentDownload(taskName,downloadId,downloadType,selectedList,cloudSite,sendEmail,callBack) {
        var fileNameList = [];
        var selectedSize = 0;
        selectedList.forEach(file => {
            fileNameList.push(file.name);
            selectedSize += parseFloat(file.size);
        });

        // 名称检查
        if (!downloadType || !cloudSite) {
            this.showBannel(this.direction.$t('language.remoteTask.unKnownError'), "subfile");
            callBack();
            return;
        }
        if (fileNameList.length == 0) {
            this.showBannel(this.direction.$t('language.popup.cloudTransferPopup.pleaSelect'), "subfile");
            callBack();
            return;
        }
        
        var options = {};
        //任务设置信息，包括任务名和是否发送邮件
        options.name = taskName;
        if(sendEmail){
            options.email = sendEmail;
        }
        var requestData = new taskOfflineUtils.addTorrentTask(commonUtils.getUser().id,downloadId, downloadType, fileNameList, cloudSite, selectedSize, options);

        requestUtils.doTorrentRequest('add', requestData).then(res => {
            if(res.status == 200) {
                callBack(res);
            }else {
                let text;
                if(res.reason == 'TOMPF') {
                    text = this.direction.$t('language.remoteTask.taskExpired');
                }
                if(res.reason == 'trafficNotEnough'){
                    text = this.direction.$t('language.popup.upgradeAccountPopup.insufficientTrafficDes');
                }
                if(res.reason == 'taskMaximumNumberLimited'){
                    text = this.direction.$t('language.exception.exceedMaxLimit');
                }
                this.showBannel(text == null ? this.direction.$t('language.exception.' + res.reason):text, "subfile");
                callBack();
            }
        }, err => {
            this.showBannel(err, "allBox");
            callBack();
        });
    },
    //报错提示
    showBannel(reason, idValue) {
        this.direction.$toast({
            text: reason,
            type: 'fail',
            idValue: idValue
        });
    },
}


// WEBPACK FOOTER //
// ./src/js/workspace/remote_task_util.js